import(/* webpackMode: "eager" */ "/home/ubuntu/download/69b262c2886e100014f5867d/easymedical/src/app/not-found.tsx");
